module.exports = __webpack_public_path__ + "img/verifyPerson.4a3f1637.png";